import React, { useState, useEffect } from 'react';
import './Videos.css';
import { videosAPI } from '../utils/api/adminAPI';

function Videos() {
  const [activeTab, setActiveTab] = useState('all');
  const [allVideos, setAllVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      setLoading(true);
      const response = await videosAPI.getAllVideos(1, 100);
      if (response.success) {
        setAllVideos(response.videos);
      }
    } catch (err) {
      setError('Failed to load videos');
      console.error('Error fetching videos:', err);
    } finally {
      setLoading(false);
    }
  };

  // Get videos for current tab
  const currentVideos =
    activeTab === 'all'
      ? allVideos
      : allVideos.filter((video) => video.category === activeTab);

  const categories = [
    { id: 'all', label: 'सभी वीडियो' },
    { id: 'News', label: 'खबरें' },
    { id: 'Technology', label: 'तकनीक' },
    { id: 'Entertainment', label: 'मनोरंजन' },
    { id: 'Sports', label: 'खेल' },
    { id: 'Politics', label: 'राजनीति' }
  ];

  // Extract video ID from YouTube URL
  const getYoutubeId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  return (
    <div className="videos-page">
      {/* HEADER */}
      <section className="videos-header section">
        <div className="container">
          <h1>🎬 वीडियो</h1>
          <p className="videos-subtitle">
            हमारी सबसे महत्वपूर्ण वीडियो सामग्री और राजनीतिक विश्लेषण देखें
          </p>

          {/* CATEGORY TABS */}
          <div className="video-tabs">
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={activeTab === cat.id ? 'tab-btn active' : 'tab-btn'}
                onClick={() => setActiveTab(cat.id)}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* VIDEO GRID */}
      <section className="videos-content section primary">
        <div className="container">
          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>वीडियो लोड हो रहे हैं...</p>
            </div>
          ) : error ? (
            <div className="error-container">
              <p>❌ {error}</p>
              <button className="btn btn-primary" onClick={fetchVideos}>
                दोबारा कोशिश करें
              </button>
            </div>
          ) : currentVideos.length === 0 ? (
            <div className="no-videos">
              <p>📭 कोई वीडियो उपलब्ध नहीं</p>
            </div>
          ) : (
            <div className="videos-grid">
              {currentVideos.map((video) => {
                const youtubeId = getYoutubeId(video.youtubeLink);
                const thumbnail =
                  video.thumbnail ||
                  `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

                return (
                  <article key={video._id} className="video-card card">
                    <div className="video-thumbnail">
                      <img
                        src={thumbnail}
                        alt={video.title}
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
                        }}
                      />

                      <a
                        href={video.youtubeLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="play-button"
                      >
                        ▶
                      </a>

                      <span className="video-category">{video.category}</span>
                    </div>

                    <div className="video-info">
                      <h3>{video.title}</h3>

                      <p className="video-description">
                        {video.description.substring(0, 100)}...
                      </p>

                      <div className="video-meta">
                        <span>📅 {new Date(video.createdAt).toLocaleDateString('hi-IN')}</span>
                      </div>

                      <a
                        href={video.youtubeLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="watch-btn"
                      >
                        YouTube पर देखें →
                      </a>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* YOUTUBE CTA */}
      <section className="videos-cta section">
        <div className="container text-center">
          <h2>📺 हमारे यूट्यूब चैनल को सबस्क्राइब करें</h2>
          <p>रोज़ाना नई वीडियो सामग्री के लिए</p>

          <button className="btn btn-primary">
            यूट्यूब पर सबस्क्राइब करें
          </button>
        </div>
      </section>
    </div>
  );
}

export default Videos;